import { CircularProgress, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import OnBoardingPop from "./OnBOardingPop";
import { toast, ToastContainer } from "react-toastify";

function CognitoPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const accountRedirectFun = () => {
    window.location.href = `${global.congito}/auth?app=ticketing&redirect=${global.domain}/auth`;
  };

  const [sales, setSales] = useState(false);

  useEffect(() => {
    try {
      const query = new URLSearchParams(window.location.search);
      const redirectData = query.get("redirectData");
      console.log("redirectData", redirectData);
      if (redirectData) {
        console.log("redirectData", redirectData);
        const base64 = JSON.parse(atob(redirectData));
        handleCognitoVerification(base64);
      } else {
        accountRedirectFun();
      }
    } catch (error) {
      accountRedirectFun();
    }
  }, []);

  const handleCognitoVerification = async (decode) => {
    localStorage.clear();
    const payload = {
      cognitoUserId: decode.userId,
      emailId: decode.email,
      source: "Web",
      fcmToken: "",
      refreshToken: decode.refreshToken,
      deviceKey: decode.deviceKey,
    };
    localStorage.setItem("refreshToken", decode.refreshToken);
    localStorage.setItem("cognitoUserId", decode.userId);

    try {
      const response = await $axios.post("auth/verifyCognito", payload);
      console.log("response12", response.data);

      if (response.data.Status === 200) {
        if (response.data.code === "003") {
          localStorage.setItem(
            "cognitoToken",
            JSON.stringify(response.data?.Message?.token)
          );
          dispatch({
            type: "SET_USER_IN",
            logindata: response.data.Message,
            payload: true,
          });
          navigate("/app/Dashboard");
        } else if (response.data.code === "002") {
          toast.error("Please Contact your Administrator");
        } else if (response.data.code === "001") {
          setSales(true);
          navigate("/tSignUp", { state: response.data.orgName });
        }
      } else {
        toast.error(response.data.Message);
      }
    } catch (error) {
      console.error("Cognito Verification Error33:", error);
    }
  };

  return (
    <>
      {/* <Grid
        container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress color="inherit" size="3rem" />
      </Grid>
      {sales && <OnBoardingPop sales={sales} setSales={setSales} />}
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      /> */}
    </>
  );
}

export default CognitoPage;
